/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Check_EmailInputs */

const en_signin_check_email = /** @type {(inputs: Signin_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const id_signin_check_email = /** @type {(inputs: Signin_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cek emailmu`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Signin_Check_EmailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_check_email = /** @type {((inputs?: Signin_Check_EmailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Check_EmailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_check_email(inputs)
	return en_signin_check_email(inputs)
});